// extracted by mini-css-extract-plugin
export default {"button":"AffiliateButton_button__Ga10-","link":"AffiliateButton_link__r88jp","linkFuild":"AffiliateButton_linkFuild__uZZI9"};